/* DELAIA — galerie fiche produit : points indicateurs (mobile swipe + ordinateur scroll, style NAMA) */
(function(){
  /* ── MOBILE : carrousel horizontal + points sous la galerie ── */
  function setupMobile(){
    var gallery = document.querySelector('.pdp-gallery');
    if (!gallery || gallery.dataset.delaiaDots) return;
    var cells = gallery.querySelectorAll('.pdp-gallery-cell');
    if (cells.length < 2) return;
    gallery.dataset.delaiaDots = '1';

    var dots = document.createElement('div');
    dots.className = 'pdp-dots';
    dots.setAttribute('data-pdp-dots', '');
    for (var i = 0; i < cells.length; i++) {
      (function(idx){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (idx + 1));
        if (idx === 0) b.className = 'active';
        b.addEventListener('click', function(){
          gallery.scrollTo({ left: idx * gallery.clientWidth, behavior: 'smooth' });
        });
        dots.appendChild(b);
      })(i);
    }
    gallery.parentNode.insertBefore(dots, gallery.nextSibling);

    var btns = dots.querySelectorAll('button');
    var t;
    gallery.addEventListener('scroll', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        for (var i = 0; i < btns.length; i++) { btns[i].classList.toggle('active', i === idx); }
      }, 40);
    }, { passive: true });
  }

  /* ── MOBILE : zoom à deux doigts (pincement) sur chaque photo, style app ── */
  function setupMobileZoom(){
    if (!('ontouchstart' in window)) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    var gallery = document.querySelector('.pdp-gallery');
    if (!gallery || gallery.dataset.delaiaZoom) return;
    var cells = gallery.querySelectorAll('.pdp-gallery-cell');
    if (!cells.length) return;
    gallery.dataset.delaiaZoom = '1';

    var MAX = 3;

    /* Passe l'image en haute résolution au 1er pincement (reste léger au chargement) */
    function hiresUrl(src){
      var target = Math.min(5760, Math.round((window.innerWidth || 400) * (window.devicePixelRatio || 2) * MAX));
      if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + target);
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + target;
    }

    cells.forEach(function(cell){
      var img = cell.querySelector('img');
      if (!img) return;
      img.style.transformOrigin = '0 0';
      img.style.willChange = 'transform';
      img.style.backfaceVisibility = 'hidden';
      img.style.transform = 'translate3d(0,0,0) scale(1)';
      img.style.touchAction = 'pan-x pan-y';

      function upgrade(){
        if (img.dataset.hires) return;
        img.dataset.hires = '1';
        var hd = hiresUrl(img.currentSrc || img.src);
        var pre = new Image();
        var swap = function(){ img.src = hd; };
        pre.onload = function(){
          // décoder hors du thread principal puis échanger sans saccade
          if (pre.decode) { pre.decode().then(swap).catch(swap); }
          else { swap(); }
        };
        pre.src = hd;
      }

      var scale = 1, tx = 0, ty = 0;
      var rafId = null;
      function apply(){
        if (rafId) return;
        rafId = requestAnimationFrame(function(){
          rafId = null;
          img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
        });
      }
      var pinching = false, panning = false;
      var startDist = 0, startScale = 1, startTx = 0, startTy = 0;
      var fx = 0, fy = 0;            // point focal (dans la cellule) au début du pincement
      var lastX = 0, lastY = 0;      // dernier point (déplacement à un doigt)

      function dist(t1, t2){
        var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function clampT(){
        var w = cell.clientWidth, h = cell.clientHeight;
        var minX = w * (1 - scale), minY = h * (1 - scale);
        if (tx > 0) tx = 0; if (tx < minX) tx = minX;
        if (ty > 0) ty = 0; if (ty < minY) ty = minY;
      }
      function reset(){
        scale = 1; tx = 0; ty = 0;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        img.style.transition = 'transform .25s ease';
        img.style.transform = 'translate3d(0,0,0) scale(1)';
        setTimeout(function(){ img.style.transition = ''; }, 280);
        gallery.style.overflowX = '';
      }

      cell.addEventListener('touchstart', function(e){
        if (e.touches.length === 2){
          pinching = true; panning = false;
          upgrade();
          startDist = dist(e.touches[0], e.touches[1]);
          startScale = scale; startTx = tx; startTy = ty;
          var r = cell.getBoundingClientRect();
          fx = (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left;
          fy = (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top;
          gallery.style.overflowX = 'hidden';
          e.preventDefault();
        } else if (e.touches.length === 1 && scale > 1){
          panning = true;
          lastX = e.touches[0].clientX; lastY = e.touches[0].clientY;
        }
      }, { passive: false });

      cell.addEventListener('touchmove', function(e){
        if (pinching && e.touches.length === 2){
          var d = dist(e.touches[0], e.touches[1]);
          var ns = startScale * (d / startDist);
          if (ns < 1) ns = 1; if (ns > MAX) ns = MAX;
          // garder le point focal du pincement fixe sous les doigts
          tx = fx - (ns / startScale) * (fx - startTx);
          ty = fy - (ns / startScale) * (fy - startTy);
          scale = ns;
          clampT();
          apply();
          e.preventDefault();
        } else if (panning && e.touches.length === 1 && scale > 1){
          var x = e.touches[0].clientX, y = e.touches[0].clientY;
          tx += x - lastX; ty += y - lastY;
          lastX = x; lastY = y;
          clampT();
          apply();
          e.preventDefault();
        }
      }, { passive: false });

      function end(e){
        if (e.touches.length < 2) pinching = false;
        if (e.touches.length === 0){
          panning = false;
          if (scale <= 1.02) reset();
          else gallery.style.overflowX = 'hidden';
        }
      }
      cell.addEventListener('touchend', end, { passive: false });
      cell.addEventListener('touchcancel', end, { passive: false });
    });
  }

  /* ── ORDINATEUR : points verticaux ancrés au bord de la galerie (restent collés aux photos, même en zoomant) ── */
  function setupDesktop(){
    var gallery = document.querySelector('.pdp-gallery');
    if (!gallery || gallery.dataset.delaiaVDots) return;
    var cells = gallery.querySelectorAll('.pdp-gallery-cell');
    if (cells.length < 2) return;
    gallery.dataset.delaiaVDots = '1';

    var rail = document.createElement('div');
    rail.className = 'pdp-dots-v';
    var btns = [];
    for (var i = 0; i < cells.length; i++) {
      (function(idx){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (idx + 1));
        if (idx === 0) b.className = 'active';
        b.addEventListener('click', function(){
          cells[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        rail.appendChild(b);
        btns.push(b);
      })(i);
    }

    /* Ancrage dans la galerie (et non à l'écran) : les points suivent les photos au zoom */
    if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
    rail.style.position = 'absolute';
    rail.style.right = '10px';
    rail.style.top = '0px';
    rail.style.transform = 'none';
    gallery.appendChild(rail);

    var strip = document.querySelector('.pdp-strip');
    function update(){
      var gr = gallery.getBoundingClientRect();
      var mid = window.innerHeight / 2;
      /* Garder les points centrés verticalement dans l'écran, mais mesurés dans la galerie */
      var top = mid - gr.top - rail.offsetHeight / 2;
      var maxTop = gallery.clientHeight - rail.offsetHeight - 10;
      if (top < 10) top = 10;
      if (top > maxTop) top = maxTop;
      rail.style.top = top + 'px';
      /* Masquer les points quand la galerie ne traverse plus le centre OU quand la bande blanche approche */
      var stripTop = strip ? strip.getBoundingClientRect().top : Infinity;
      var inView = (gr.top < mid) && (gr.bottom > mid) && (stripTop > window.innerHeight * 0.72);
      rail.style.opacity = inView ? '1' : '0';
      rail.style.pointerEvents = inView ? 'auto' : 'none';
      if (!inView) return;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < cells.length; i++) {
        var cr = cells[i].getBoundingClientRect();
        var c = cr.top + cr.height / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      for (var j = 0; j < btns.length; j++) { btns[j].classList.toggle('active', j === best); }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function setup(){ setupMobile(); setupMobileZoom(); setupDesktop(); }
  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();
